import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'inpc.list.pagination', {});
export const getFilters = (state) => get(state, 'inpc.list.filters', {});

export const getInpcIds = (state) => get(state, 'inpc.list.result.inpc', []);
export const getInpc = (state) => get(state, 'inpc.list.entities.inpc', {});

export const getIsLoading = (state) => get(state, 'inpc.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'inpc.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'inpc.form.isFetching', false);
export const getIsSaving = (state) => get(state, 'inpc.form.isSaving', false);
export const getEditing = (state) => get(state, 'inpc.form.editing', {});

export const getVisibleInpc = createSelector([getInpcIds, getInpc], (ids, inpcs) =>
  ids.map((id) => inpcs[id]).filter((account) => !account.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/selectors/inpc_selectors.js